import { set } from "lodash";
import { createStore } from "vuex";
import Cookies from "js-cookie";

export default createStore({
  state: {
    tstime: [],
    //-----------------------
    // 播放器控件数据
    videoCurrentTime: 0, // 当前视频播放时间
    videoCurrentTotaTime: 0, // 当前视频总时长
    videoConTrolData: {
      // 自定义控制条数据 ( 禁止覆盖此对象 覆盖后 将监听不到对象内部字段变化)
      playbackNum: 0, // 回放段落 用于控制播放器播放第几段 最终确认播放第几段 (等待LeadVideoNum 切换逻辑处理完成后 改变 playbackNum 值)
      LeadVideoNum: 0, // 主角播放器是否播放完成 完成更改此状态 （多段视频播放默认第一个 可手动选择视频列表控制播放段落）（监听此状态播放下一段视频并执行过滤出视频时长最大的）
      isPaused: false, // false暂停 true播放
      refresh: 2024, // 刷新
      rate: 1.0, // 当前倍速
      liveUrlType: "m3u8HighStream", // 清晰度 // m3u8HighStream高清 // m3u8SuperStream超清
      volume: 0, // 音量
      mutedState: true, // 静音
      isBig: false, // false小屏  true 大屏 *暂时弃用 已用自定义方法实现 具体方法到-->（src\views\Frontpage\TeachingActivities\components\controlStrip）*
      currentTime: "", // 当前播放时长 原数据（秒）
      currentTimeDispose: "0:00", // 当前播放时长
      TotalTime: "", // 总时长 原数据（秒）
      TotalTimeDispose: "0:00", //总时长 转移后00:00:00 用于展示
      allPlaysEnd: false, // 当前课堂画面回放段落播放完毕 false 未播放完 / true 已播放完
    },
    VideoLoadeState: false, // 视频加载状态 false 未加载完成 / true 已加载完成
    VideoCurrentOpenTime: "", // 点击或 拖动进度条时间 / 打点跳转时间  (接收秒数)
    VideoCurrentopenObj: { // 当前点击或 拖动进度条时间 / 打点跳转时间  (接收秒数) 对象
      VideoCurrentOpenTime: "",
      newdate: "",// 时间戳 重复点击不触发问题
    },
    loadWaiting: "", // 视频是否缓冲了状态(用来控制多个播放器为暂停/加载状态)使所有播放器播放时间一致
    mutedStateS: [true, true, true], // 单独实例小屏控制静音（默认三个分屏 三个以上可像数组内扩展）
    // 单独实例小屏控制静音
    //-----------------------
    teacherPatrol: [], // 教师巡视
    studentPatrol: [], // 教师巡视（学生位置）
    teacherAiTimeVo: {}, //教师所在区域时间分布
    schoolId: "", // 登录时请求用
    showDialog: false,
    dialogData: [],
    lang: "",
    isSignUp: false, // 课程资源是否已经报名
    teaGroupInfo: {
      isTeacherMember: false, // 课程资源是否为创建人
      isCreateTeacher: false, // 课程资源是否为教师团队
      isAllowMemberManage: false, // 课程资源是否允许教师团队管理课程
    },
    //-----------------------
    screenshotState: false, // 截图状态
    screenshot: {}, // 详情截图
    //-----------------------
    noteVideoTime: {
      //  课程资源 笔记 视频时间跳转
      currentTime: "",
      courseFileid: "",
      videoNum: 0,
      screenNum: 1,
      newdate: "",// 时间戳 重复点击不触发问题
    },
    dirctoryIsUpdata: 2024, // 是否需要刷新目录数据进度
    backId:'', // 课程资源返回id
    //-----------------------
    scroolStarrysky: true, // 星空图
    fullscreen: false, // 全屏状态 星空图
    subtitleMode: 'showing', // 初始状态：显示字幕
    subtitleParams: {
      businessId: "",
      businessType: "", // 1:精品课 2:直播 3:课例评课 4:教研直播 5:教研互动 6:系列课 7:远程互动 8:课表 9:其他 
      videoSource: "",
    }, // 字幕传参
    knowledgState: false, // 知识图谱资源显示状态
  },
  getters: {
    geTtstime: (state) => state.tstime,
    getImgArray: (state) => state.imgArray,
    getVideoCurrentTime: (state) => state.videoCurrentTime,
    getVideoCurrentTotaTime: (state) => state.videoCurrentTotaTime,
    // getplaybackNum: (state) => state.playbackNum,
    getvideoConTrolData: (state) => state.videoConTrolData,
    getVideoCurrentOpenTime: (state) => state.VideoCurrentopenObj,//VideoCurrentOpenTime,
    getloadWaiting: (state) => state.loadWaiting,
    getmutedStateS: (state) => state.mutedStateS,
    getTeacherPatrol: (state) => state.teacherPatrol,
    getStudentPatrol: (state) => state.studentPatrol,
    getTeacherAiTimeVo: (state) => state.teacherAiTimeVo,
    getSchoolId: (state) => state.schoolId,
    getlang: (state) => state.lang,
    getVideoLoadeState: (state) => state.VideoLoadeState,

    //-----------------------
    // 截图状态
    getScreenshotState: (state) => state.screenshotState,
    // 详情截图
    getScreenshot: (state) => state.screenshot,
    //-----------------------
    getNoteVideoTime: (state) => state.noteVideoTime,
    getDirctoryIsUpdata: (state) => state.dirctoryIsUpdata,
    getBackId: (state) => state.backId,
    //-----------------------
    getScroolStarrysky: (state) => state.scroolStarrysky,
    getfullscreen: (state) => state.fullscreen,
    isSubtitleShown: state => state.subtitleMode === 'showing',
    getSubtitleParams: (state) => state.subtitleParams, // 新增
    getknowledgState: (state) => state.knowledgState,
  },
  mutations: {
    openvideoDotTxt(state, row) {
      state.tstime = row;
    },
    updateVideoCurrentTime(state, currentTime) {
      // console.log('456//'+currentTime)
      state.videoCurrentTime = currentTime;
    },
    updateVideoCurrentTimeTotalTime(state, TotalTime) {
      // console.log('456//'+TotalTime)
      state.videoCurrentTotaTime = TotalTime;
    },
    // 视频加载状态
    updateVideoLoadeState(state, data) {
      console.log('视频加载状态变化', data);
      state.VideoLoadeState = data;
    },
    // 回放使用
    // updatePlaybackNum(state, data) {
    //   state.playbackNum = data;
    // },
    // 教研活动操作进度条进度条
    updataVideoCurrentOpenTime(state, data) {
      // 优化时间打点评论重复点击不触发问题
      // state.VideoCurrentOpenTime = data;
      state.VideoCurrentopenObj = {
        VideoCurrentOpenTime: data,
        newdate: new Date().getTime(),// 时间戳 重复点击不触发问题
      }
    },
    // 修改播放器实例为缓冲状态
    updataLoadWaiting(state, data) {
      state.loadWaiting = data;
    },
    // 播放器实例
    updatamutedStateS(state, data) {
      state.mutedStateS = data;
    },
    // 教师巡视
    updateTeacherPatrol(state, item) {
      state.teacherPatrol = [...state.teacherPatrol, ...item];
    },
    // 教师巡视
    updateStudentPatrol(state, item) {
      state.studentPatrol = [...state.studentPatrol, ...item];
    },
    // 更新各个行为峰值数据
    updateTeacherAiTimeVo(state, data) {
      state.teacherAiTimeVo = data;
    },
    setSchoolId(state, row) {
      state.schoolId = row;
      Cookies.set("schoolId", row);
    },
    setDialogVisibility(state, isVisible) {
      state.showDialog = isVisible;
    },
    setDialogData(state, data) {
      state.dialogData = data;
    },
    setTokenValue(state, data) {
      state.tokenValue = data;
    },
    uploadlang(state, data) {
      state.lang = data;
    },
    setIsSignUp(state, data) {
      state.isSignUp = data;
    },
    setTeaGroupInfo(state, data) {
      state.teaGroupInfo = data;
    },
    //-----------------------
    // 巡课截图状态
    updateScreenshotState(state, data) {
      state.screenshotState = data;
    },
    // 巡课详情截图
    updateScreenshot(state, data) {
      state.screenshot = data;
    },
    //-----------------------
    // 是否需要刷新目录数据进度
    updateDirctoryIsUpdata(state, data) {
      state.dirctoryIsUpdata = data;
    },
    updataBackId(state, data) {
      state.backId = data;
    },
    updataScroolStarrysky(state, data) {
      state.scroolStarrysky = data;
    },
    updatafullscreen(state, data) {
      state.fullscreen = data;
    },
    TOGGLE_SUBTITLE(state) {
      state.subtitleMode = state.subtitleMode === 'showing' ? 'hidden' : 'showing';
    },
    SET_SUBTITLE(state, mode) {
      state.subtitleMode = mode;
    },
    setSubtitleParams(state, params) {
      state.subtitleParams = { ...params }; // 保证响应式
    },
    updataknowledgState(state, data) {
      state.knowledgState = data
    }
  },
  actions: {
    setopenvideoDotTxt({ commit }, list) {
      commit("openvideoDotTxt", list);
    },
    setVideoCurrentTime({ commit }, currentTime) {
      commit("updateVideoCurrentTime", currentTime);
    },
    setVideoCurrentTotalTime({ commit }, TotalTime) {
      commit("updateVideoCurrentTimeTotalTime", TotalTime);
    },
    // setPlaybackNum({ commit }, num) {
    //   commit("updatePlaybackNum", num);
    // },
    setVideoCurrentOpenTime({ commit }, data) {
      commit("updataVideoCurrentOpenTime", data);
    },
    setLoadWaiting({ commit }, data) {
      commit("updataLoadWaiting", data);
    },
    setmutedStateS({ commit }, data) {
      commit("updatamutedStateS", data);
    },
    setTeacherPatrol({ commit }, item) {
      commit("updateTeacherPatrol", item);
    },
    setStudentPatrol({ commit }, item) {
      commit("updateStudentPatrol", item);
    },
    setTeacherAiTimeVo({ commit }, data) {
      commit("updateTeacherAiTimeVo", data);
    },
    setSchoolId({ commit }, row) {
      commit("setSchoolId", row);
      Cookies.set("schoolId", row);
    },
    setDialogVisibility({ commit }, isVisible) {
      commit("setDialogVisibility", isVisible);
    },
    setDialogData({ commit }, data) {
      commit("setDialogData", data);
    },
    setTokenValue({ commit }, data) {
      commit("setTokenValue", data);
    },
    setLang({ commit }, data) {
      commit("uploadlang", data);
    },
    setIsSignUp({ commit }, data) {
      commit("setIsSignUp", data);
    },
    setTeaGroupInfo({ commit }, data) {
      commit("setTeaGroupInfo", data);
    },
    setBackId({ commit }, data) {
      commit("updataBackId", data);
    },
    //-----------------------
    // 截图状态
    setScreenshotState({ commit }, value) {
      commit("updateScreenshotState", value);
    },
    // 详情截图
    setScreenshot({ commit }, value) {
      commit("updateScreenshot", value);
    },
    //-----------------------
    // 是否需要刷新目录数据进度
    setDirctoryIsUpdata({ commit }, value) {
      commit("updateDirctoryIsUpdata", value);
    },
    setScroolStarrysky({ commit }, value) {
      commit("updataScroolStarrysky", value);
    },
    setfullscreen({ commit }, value) {
      commit("updatafullscreen", value);
    },
    setSubtitleParams({ commit }, params) { // 新增
      commit("setSubtitleParams", params);
    },
    setknowledgState({ commit }, value) {
      commit("updataknowledgState", value);
    }
  },
  modules: {},
});
